import { Button } from 'reactstrap'
import { FaCloudDownloadAlt } from 'react-icons/fa'
import { getLoginInfo, setLocalStorage } from '../../utils'

export default function UpdateClientButton(props) {
  console.log('UpdateClientButton rendered')
  const { versions } = props

  function clicked(e) {
    console.log('UpdateClientButton: clicked', e)
    e.target.innerHTML = e.target.innerHTML.replace(`Update Required (${versions.oldVersion})`, `Updating to ${versions.newVersion}...`)
    const oldLoginInfo = getLoginInfo()
    oldLoginInfo.configuration['CLIENT VERSION'] = `${versions.newVersion}`
    setLocalStorage(oldLoginInfo.tenant, JSON.stringify(oldLoginInfo))
    window.location.reload()
  }

  return (
    <Button style={{ marginLeft: '8px'}} color="warning" onClick={clicked} data-cy="navbar-sidebar-button">
      < FaCloudDownloadAlt style={{ width: '1.25rem', height: '1.25rem' }} /> Update Required ({versions.newVersion})
    </Button >
  )
}
